import $$ from 'cmn-utils'
import template from './template'
const baseUrl = "/api/safety/position/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    template
}